<template>
<div class="podcasts_page page">

	<topheader back="back">
		<template v-slot:info>
			<span>{{$t('snippity.podcasts')}}</span>
		</template>
	</topheader>

	<maincontent>
		<template v-slot:content>
            <podcasts />
		</template>
	</maincontent>

</div>
</template>

<style scoped lang="sass">

</style>

<script>

import podcasts from "@/components/modules/podcasts/index.vue";

export default {
	name: 'podcasts_page',
	components: {
        podcasts
	},

	computed: {

	},

	methods: {

	},

	mounted() {

	}
}
</script>
